import { c as _c } from "react/compiler-runtime";
import type { ProcessedContent } from "./media-utils";
import ContentSegmentComponent from "./ContentSegmentComponent";
import MediaThumbnail from "./MediaThumbnail";
interface ContentDisplayProps {
  readonly content: ProcessedContent;
  readonly onClick?: () => void;
  readonly className?: string | undefined;
  readonly textClassName?: string | undefined;
  readonly shouldClamp?: boolean;
}

/**
 * Component to display processed content with text segments and media
 */
export default function ContentDisplay(t0) {
  const $ = _c(18);
  const {
    content,
    onClick,
    className,
    textClassName,
    shouldClamp: t1
  } = t0;
  const shouldClamp = t1 === undefined ? true : t1;
  const clampClass = shouldClamp ? "tw-line-clamp-1" : "";
  const t2 = onClick ? "tw-cursor-pointer hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out" : "";
  const t3 = className ?? "";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = ["tw-text-iron-300 tw-font-normal tw-text-sm tw-flex tw-items-center tw-gap-1.5", t2, t3].filter(Boolean);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const containerClasses = t4.join(" ");
  const t5 = textClassName ?? "";
  let t6;
  if ($[3] !== clampClass || $[4] !== t5) {
    t6 = [clampClass, t5].filter(Boolean);
    $[3] = clampClass;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const textClasses = t6.join(" ");
  let t7;
  if ($[6] !== content.segments) {
    t7 = content.segments.map(_temp);
    $[6] = content.segments;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t7 || $[9] !== textClasses) {
    t8 = <span className={textClasses}>{t7}</span>;
    $[8] = t7;
    $[9] = textClasses;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== content.apiMedia) {
    t9 = content.apiMedia.map(_temp2);
    $[11] = content.apiMedia;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== containerClasses || $[14] !== onClick || $[15] !== t8 || $[16] !== t9) {
    t10 = <span className={containerClasses} onClick={onClick}>{t8}{t9}</span>;
    $[13] = containerClasses;
    $[14] = onClick;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  return t10;
}
function _temp2(media, i_0) {
  return <MediaThumbnail key={`api-media-${i_0}`} media={media} />;
}
function _temp(segment, i) {
  return <ContentSegmentComponent key={`segment-${i}`} segment={segment} index={i} />;
}